import { IFilters } from '@datx/jsonapi/interfaces/IFilters';
import { LearningUnitJsonModel } from '../learning-unit.json.model';
import { HttpErrorResponse } from '@angular/common/http';

export namespace LearningUnitActions {
  export class Add {
    static readonly type = getActionName('Add');
    constructor(
      public payload: LearningUnitJsonModel,
      public filters?: IFilters
    ) { }
  }

  export class Delete {
    static readonly type = getActionName('Delete');
    constructor(readonly payload: LearningUnitJsonModel) { }
  }

  export class Edit {
    static readonly type = getActionName('Edit');
    constructor(
      public payload: LearningUnitJsonModel,
      public filters?: IFilters
    ) { }
  }

  export class Fetch {
    static readonly type = getActionName('Fetch');

    public include: string;
    public overrideOptions?: {
      pageNumber?: number
      pageSize?: number
      skipStoreDispatch?: boolean
    };

    constructor(
      include?: string,
      overrideOptions?: {
        pageNumber?: number
        pageSize?: number
        skipStoreDispatch?: boolean
      }
    ) {
      this.include = include === undefined ?
        'learningSections' :
        include;

      this.overrideOptions = overrideOptions;
    }
  }

  export class FetchOne {
    static readonly type = getActionName('Fetch One');
    constructor(public id: string) { }
  }

  export class FetchOneSuccess {
    static readonly type = getActionName('Fetch One Success');
    constructor(public payload: LearningUnitJsonModel) { }
  }

  export class FetchOneFailure {
    static readonly type = getActionName('Fetch One Failure');
    constructor(public error: HttpErrorResponse) { }
  }

  export class FetchWithFilters {
    static readonly type = getActionName('Fetch with filters');

    public include: string;

    constructor(
      public readonly filters: IFilters,
      include?: string
    ) {
      this.include = include === undefined ?
        'learningSections' :
        include;
    }
  }

  export class FetchSuccess {
    static readonly type = getActionName('Fetch success');
    constructor(readonly payload: LearningUnitJsonModel[]) { }
  }

  function getActionName(type: string) {
    return `[LearningUnit] ${type}`;
  }
}
